var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-start d-inline-flex align-center"},[_c('country-flag',{staticStyle:{"margin":"-15px"},attrs:{"country":_vm.itemCountry,"size":_vm.size}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.itemLabel)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }